import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { withStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import Button from "components/CustomButtons/Button.js";
import AddIcon from "@mui/icons-material/Add";
import Tooltip from "@mui/material/Tooltip";
import CreateElementfilesDialog from "./CreateElementfilesDialog.js";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles = makeStyles(styles);

export default function CreateElementfiles({ refetch }) {
  const [open, setOpen] = useState(false);
  const classes = useStyles();
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div>
      <Tooltip title="Ajouter un élément">
        <Button
          onClick={handleClickOpen}
          color={"success"}
          className={classes.actionButton}
        >
          <AddIcon fontSize="large" />
        </Button>
      </Tooltip>
      <Dialog
        onClose={handleClose}
        aria-labelledby="addMarket-dialog-title"
        fullWidth={true}
        maxWidth="sm"
        open={open}
      >
        <CustomDialogTitle id="addMarket-dialog-title" onClose={handleClose}>
          Ajout d'un élément
        </CustomDialogTitle>
        <DialogContent dividers>
          <CreateElementfilesDialog closeModal={handleClose} refetch={refetch} />
        </DialogContent>
        <DialogActions />
      </Dialog>
    </div>
  );
}
